export default __webpack_public_path__ + "static/media/bundle-guide-me-us-white@1x.7b4e98ce.jpg";